import getModalGradient from 'utils/getModalGradient';

// @ts-ignore
import concentrationBanner from '@common/assets/images/profile-background-default.webp';

export default {
	modal: {
		modalGradient: getModalGradient('#F3F9FF', '#EBF1F5'),
		color1: '#F3F9FF',
		color2: '#EBF1F5',
	},
	banner: concentrationBanner,
	primary: {
		main: '#2090FF',
		contrastText: '#E8F4FF',
	},
	text: {
		primary: '#171A1C',
		secondary: '#474747',
		subTitle: '#C1C1C1',
		helper: '#5C5C5C',
		white: '#FFF',
		black: '#000',
		headLine: '#111827',
		md500: '#858585',
	},
	success: {
		contrastText: '#39763c',
		main: '#e2f2e2',
	},
	error: {
		main: '#ffe8e8',
		// main: '#c41c1c',
		contrastText: '#d81313',
	},
	warning: {
		main: '#FFECD6',
		contrastText: '#F99118',
	},
	info: {
		main: '#d9edfc',
		contrastText: '#0070c6',
	},
	radio: {
		main: '#e3e9fe',
	},
};
